
import Multiselect from 'vue-multiselect'
export default {
  components: {
    Multiselect
  },
  props: {
    privateEventUnlocked: {
      type: Boolean,
      default: false
    },
    event: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    actions: ['standticket', 'seatticket'],
    loading: false
  }),
  methods: {
    async privateEvent(data) {
      this.loading = true
      try {
        await this.$store.dispatch('event/checkPrivate', {
          event: this.event.id,
          promocode: data.code
        })

        if (this.$store.getters['event/isUnlocked'](this.event.id)) {
          return this.$router.push(
            this.localePath({
              name: 'events-eid-tickets',
              params: { eid: this.event.id }
            })
          )
        }
      } catch (e) {
      } finally {
        this.loading = false
      }
    },
    dispatchAction(type) {
      this.$router.push(
        this.localePath({
          name: 'events-eid-tickets',
          params: { eid: this.event.id },
          query: { type }
        })
      )
    }
  }
}
